// CrossSelling.tsx
import "./crossSelling.css";
import "../../ReferEarn/comopnents/refer.css";

import React, { useContext, useEffect, useRef, useState } from "react";
import QuestContext from "../../../../components/QuestWrapper";
import General, { useGeneral } from "../../../../general";
import {
  grabDealIcon,
  grabDealIcon2,
} from "../../../../components/expansion/Svg";
import { PrimaryButton } from "../../../../components/Modules/PrimaryButton";
import Label from "../../../../components/Modules/Label";
import { Input } from "../../../../components/Modules/Input";
import { SecondaryButton } from "../../../../components/Modules/SecondaryButton";
import QuestLabs from "../../../../components/QuestLabs";
import CrossSellingApi from "./crossSellingApi";
import {
  CrossSellingProps,
  BrandTheme,
  QuestThemeData,
  TimeLeft,
} from "./CrossSellingType";
import CrossSellingThemeManager from "./CrossSellingThemeManager";
import { Gift, Percentage } from "./SVG";

export const CrossSellingWrapper: React.FC<CrossSellingProps> = ({
  questId = "",
  userId = "",
  token = "",
  heading = "50% off on limited products",
  description = "Grab deals before they go off!!!",
  shareButtonText = "Avail now",
  gradientBackground = false,
  primaryHeading = "Grab your deal",
  primaryDescription = "Welcome back, Please complete your details",
  showDays = false,
  expiryDate = 0,
  isEmail = false,
  claimRewardHandler = (email?: string) => {},
  backButtonTrigger = () => {},
  uniqueEmailId,
  uniqueUserId,
  styleConfig,
  footerText = "Powered by PLG OS",
  variation,
  Icon = "gift",
  footerLink,
  entityAuthenticationToken,
}) => {
  const [email, setEmail] = useState("");
  const [questThemeData, setQuestThemeData] = useState<QuestThemeData>({
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: [],
  });
  const [brandTheme, setBrandTheme] = useState<BrandTheme>({
    accentColor: "",
    background: "",
    borderRadius: "",
    primaryButton: "",
    contentColor: "",
    fontFamily: "",
    logo: "",
    primaryColor: "",
    secondaryColor: "",
    tertiaryColor: "",
    titleColor: "",
  });
  const [showFooter, setShowFooter] = useState(true);
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const { apiKey, entityId, apiType, themeConfig, user } = useContext(
    QuestContext.Context
  );
  const requestRef = useRef<number>(expiryDate);
  const animationFrameRef = useRef<number>();

  const crossSellingApi = new CrossSellingApi(apiType);
  const GeneralFunctions = new General("mixpanel", apiType);

  const themeManager = new CrossSellingThemeManager(
    themeConfig,
    styleConfig,
    questThemeData,
    brandTheme
  );

  const general = useGeneral('quest')

  const animate = () => {
    if (!requestRef.current) return;

    const timeLeft = crossSellingApi.calculateTimeLeft(requestRef.current);
    setTimeLeft(timeLeft);

    if (Object.values(timeLeft).some((value) => value > 0)) {
      animationFrameRef.current = requestAnimationFrame(animate);
    }
  };

  useEffect(() => {
    general.trackEvent(
      'quest-cross-selling-loaded',
      (uniqueUserId || userId || user.userId)!,
      {},
      true,
      !uniqueUserId,
      true
    )
  }, []);

  const handleEmail = (email: string) => {
    if (!isEmail || crossSellingApi.validateEmail(email)) {
      GeneralFunctions.fireTrackingEvent(
        "quest_crossselling_claimed",
        "crossselling"
      );
      claimRewardHandler(email);
    }
  };

  useEffect(() => {
    if (themeConfig) themeManager.updateThemeConfig(themeConfig);
    if (styleConfig) themeManager.updateStyleConfig(styleConfig);
    if (questThemeData) themeManager.updateQuestTheme(questThemeData);
    if (brandTheme) themeManager.updateBrandTheme(brandTheme);
  }, [themeConfig, styleConfig, questThemeData, brandTheme]);

  useEffect(() => {
    const initializeCrossSelling = async () => {
      GeneralFunctions.fireTrackingEvent(
        "quest_cross_selling_loaded",
        "cross_selling"
      );

      if (!entityId || !questId || !apiKey) return;

      try {
        const userAuth = await crossSellingApi.getUserAuth({
          apiKey,
          entityId,
          uniqueUserId,
          uniqueEmailId,
          userId,
          token,
          entityAuthenticationToken,
        });

        if (!userAuth) return;

        const headers = {
          apiKey,
          userId: userAuth.userId,
          token: userAuth.token,
        };

        const response = await crossSellingApi.getCrossSellData(
          entityId,
          questId,
          headers,
          variation
        );

        if (!response) return;

        if (response.sdkConfig?.uiProps?.questThemeData) {
          setQuestThemeData(response.sdkConfig.uiProps.questThemeData);
          if (response?.sdkConfig?.uiProps?.BrandTheme) {
            setBrandTheme(response?.sdkConfig?.uiProps?.BrandTheme?.properties);
          }
        }
        if (response?.sdkConfig?.uiProps?.showFooter !== undefined) {
          setShowFooter(response?.sdkConfig?.uiProps?.showFooter);
        }

        const expiryTimestamp = +(
          Date.parse(response.endsAt) || response.endsAt
        );
        requestRef.current = expiryTimestamp || expiryDate;
        animate();
      } catch (error) {
        GeneralFunctions.captureSentryException(error);
        requestRef.current = expiryDate;
        animate();
      }
    };

    initializeCrossSelling();

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [entityId, apiKey, questId, uniqueUserId, uniqueEmailId]);

  const renderTimer = () => (
    <div className="q_time_left">
      {showDays && timeLeft.days > 0 && (
        <div
          className="q_hours_left"
          style={themeManager.getTimerStyles().card}
        >
          <div style={themeManager.getTimerStyles().primaryText}>
            {timeLeft.days}
          </div>
          <div
            className="q_time_left_text"
            style={themeManager.getTimerStyles().secondaryText}
          >
            Days
          </div>
        </div>
      )}
      {["hours", "minutes", "seconds"].map((unit) => (
        <div
          key={unit}
          className={`q_${unit}_left`}
          style={themeManager.getTimerStyles().card}
        >
          <div style={themeManager.getTimerStyles().primaryText}>
            {timeLeft[unit as keyof TimeLeft] < 10 ? "0" : ""}
            {timeLeft[unit as keyof TimeLeft]}
          </div>
          <div
            className="q_time_left_text"
            style={themeManager.getTimerStyles().secondaryText}
          >
            {unit.charAt(0).toUpperCase() + unit.slice(1)}
          </div>
        </div>
      ))}
    </div>
  );

  const renderEmailInput = () =>
    isEmail && (
      <div style={{ width: "100%" }}>
        <Label
          htmlFor="normalInput"
          children="Email Address"
          style={themeManager.getInputStyles().label}
        />
        <Input
          type="email"
          style={themeManager.getInputStyles().input}
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          emailtext={themeManager.getInputStyles().error.text}
          emailErrorStyle={themeManager.getInputStyles().error.style}
        />
      </div>
    );

  const renderMainContent = () => (
    <div
      className="q_refer_and_earn"
      style={themeManager.getMainContentStyles()}
    >
      <div className="q_refer_head">
        {Icon == "gift" ? <Gift primary={themeManager.getIconColor().primary} secondary={themeManager.getIconColor().primary} /> : <Percentage primary={themeManager.getIconColor().primary} secondary={themeManager.getIconColor().secondary} tertiary={themeManager.getIconColor().tertiary} />}
      </div>

      <div className="q_refer_content">
        <div className="refer_content_box">
          <div
            className="q_refer_heading"
            style={themeManager.getHeadingStyles()}
          >
            {heading}
          </div>
          <div
            className="q_refer_desc"
            style={themeManager.getDescriptionStyles()}
          >
            {description}
          </div>
        </div>

        {renderTimer()}
        {renderEmailInput()}

        <PrimaryButton
          style={themeManager.getPrimaryButtonStyles()}
          onClick={() => {
            general.trackEvent(
              'quest-cross-selling-submit-click',
              (uniqueUserId || userId || user.userId)!,
              {},
              true,
              !uniqueUserId
            )
            handleEmail(email)
          }}
          className="q_share_link_button"
          disabled={isEmail && !crossSellingApi.validateEmail(email)}
        >
          {shareButtonText}
        </PrimaryButton>

        <SecondaryButton
          style={themeManager.getSecondaryButtonStyles()}
          onClick={() => {
            GeneralFunctions.fireTrackingEvent(
              "quest_challenges_secondary_btn_clicked",
              "challenges"
            );
            general.trackEvent(
              'quest-cross-selling-back-btn-click',
              (uniqueUserId || userId || user.userId)!,
              {},
              true,
              !uniqueUserId
            )
            backButtonTrigger();
          }}
          className="q_share_link_button_2"
        >
          Go to home
        </SecondaryButton>
      </div>

      {!gradientBackground && showFooter && (
        <QuestLabs
          style={themeManager.getFooterStyles().container}
          textStyle={themeManager.getFooterStyles().text}
          iconStyle={themeManager.getFooterStyles().icon}
          text={footerText}
          link={footerLink}
        />
      )}
    </div>
  );

  if (gradientBackground) {
    const gradientStyles = themeManager.getGradientStyles();
    return (
      <div style={gradientStyles.wrapper}>
        <div
          className="q_gradient_background"
          style={gradientStyles.background}
        >
          <div className="q_gradient_head">
            <div className="q_gradient_heading" style={gradientStyles.heading}>
              {primaryHeading}
            </div>
            <div
              className="q_gradient_description"
              style={gradientStyles.description}
            >
              {primaryDescription}
            </div>
          </div>
          {renderMainContent()}
          <div className="q_gradient_quest_powered">
            {showFooter && (
              <QuestLabs
                style={themeManager.getFooterStyles().container}
                textStyle={themeManager.getFooterStyles().text}
                iconStyle={themeManager.getFooterStyles().icon}
                text={footerText}
                link={footerLink}
              />
            )}
          </div>
        </div>
      </div>
    );
  }

  return renderMainContent();
};

export default CrossSellingWrapper;
